import * as api from '../../../clients/qschecks';

import {Action} from '@ngrx/store';

export const GET_FUNKTIONSBEREICHE_ROLLEN = '[QschecksModul] GetFunktionsbereicheRollen laden';
export const GET_FUNKTIONSBEREICHE_ROLLEN_AUSFUEHREN = '[QschecksModul] GetFunktionsbereicheRollen ausführen';
export const GET_FUNKTIONSBEREICHE_ROLLEN_ERFOLGREICH = '[QschecksModul] GetFunktionsbereicheRollen laden erfolgreich';
export const GET_FUNKTIONSBEREICHE_ROLLEN_FEHLER = '[QschecksModul] GetFunktionsbereicheRollen Ladefehler';
export const GET_FUNKTIONSBEREICHE_ROLLEN_NICHT_AUSGEFUEHRT = '[QschecksModul] GetFunktionsbereicheRollen nicht ausgeführt (evtl. Offline)';


export class GetFunktionsbereicheRollenAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenAusfuehrenAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenErfolgreichAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_ERFOLGREICH;
        constructor(public payload: Array<api.FunktionsbereichRollen>, public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenFehlerAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetFunktionsbereicheRollenNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKTIONSBEREICHE_ROLLEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type QschecksQueryFunktionsbereicheRollenActions =
    GetFunktionsbereicheRollenAction
    | GetFunktionsbereicheRollenAusfuehrenAction
    | GetFunktionsbereicheRollenErfolgreichAction
    | GetFunktionsbereicheRollenFehlerAction
    | GetFunktionsbereicheRollenNichtAusgefuehrtAction
    ;
